import { Component, OnInit, Inject, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { ClipboardService } from 'ngx-clipboard';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
  tenant: string;
  title: string;
  description: string;
  descriptionError: string;
  descriptionArray: any;
  errorArray:any;
  descriptionArrayLength: number;
  errorArrayLength: number;
  defaultLinkTitle: string = translate('ERROR_DIALOG.VIEW_MORE');
  defaultLinkTitleLess: string = translate('ERROR_DIALOG.VIEW_LESS');
  copy: boolean;
  errorMessage: any;
  errorMessages: any;
  copyData: any;
  copyErrorText: any;
  hideReportButton: boolean;
  newDescription: any;
  internalError = false;
  errorDesc: any[];
  isErrorDescription = false;
  source: any;
  target: any;
  alertError: boolean;
  note: any;
  errorDetails: any;
  noPermission: boolean;
  restoreError: boolean = false;
  scheduleDescription: any
  coolingPeriod:any

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private clipboardApi: ClipboardService,
  public matdialogRef: MatDialogRef<ErrorDialogComponent>,
  private sideNav: SidenavService, private authService: AuthService, private translocoService: TranslocoService) {
    this.hideReportButton = data.hideReportButton;
    this.title = data.title;
    this.source = data.source;
    this.target = data.target;
    this.alertError = data.alertError;  
    const fieldErrors = data.description?.fieldErrors;
    this.internalError = data.internalError;
    this.note = data.note;
    this.errorDetails = data.errorDetails;
    this.noPermission = data.noPermission;
    this.restoreError = this.data?.restoreError || false;
    this.scheduleDescription = this.data.scheduleDescription;
    this.coolingPeriod = this.data.coolingPeriod;
    if(data.description?.error?.details?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of data.description?.error?.details){
        this.descriptionArray.push(errorMessage);
      }
      this.descriptionArrayLength = data.description?.error?.details?.length;
    }
    if(data.description?.details?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of data.description?.details){
        this.descriptionArray.push(errorMessage);
      }
      this.descriptionArrayLength = data.description?.details?.length;
    }
    if(fieldErrors?.length > 0) {
      this.descriptionArray = [];
      for (const errorMessage of fieldErrors){
        this.descriptionArray.push(errorMessage);
      }
      this.descriptionArrayLength = data.description?.fieldErrors?.length;
    }
    if (data?.error) {
      this.errorMessage = data?.error;
    }
    if (data.description?.messages) {
      this.errorMessage = data.description.messages[0];
    } else if(data.description?.message){
      this.errorMessage = data.description.message;
    } else if(data.description?.errmsg){
      this.errorMessage = data.description.errmsg;
    } else if(data.description?.error?.message){
      this.errorMessage = data.description.error.message;
    } else if(this.descriptionArrayLength > 0){ 
      this.errorMessage = data.subtitle?.length > 32 ? data.subtitle?.substring(0, 32) + '...' : data.subtitle;
    } else {
      if (data.description?.error  === translate('ERROR_DIALOG.NOT_FOUND')) {
        this.errorMessage = translate('ERROR_DIALOG.API_NOT_AVAILABLE');
      } else if (data.description) {
        this.errorMessage = typeof data.description === 'string'? data.description : 'An unknown error occurred.';
      } else if (data.description?.error  !== translate('ERROR_DIALOG.NOT_FOUND')) {
        this.errorMessage = data.description?.error;
      }
    }
    this.newDescription = data.newDescription;
    this.description = this.errorMessage;
    if(this.descriptionArray !== undefined) {
      this.descriptionArray = this.descriptionArray;
    }

    this.hideReportButton = data.hideReportButton;
    this.title = data.title;
    const popupErrors = data.descriptionError?.fieldErrors;
    if(data.descriptionError?.length > 0) {
      this.errorArray = [];
      const flattened = data.descriptionError.flat();
      this.errorArray = flattened?.map(err => {
        const obj: any = {};
        if (err?.code) obj.code = err?.code;
        if (err?.message) obj.message = err?.message;
        if (err?.details) obj.details = err?.details;
        if (err?.source) obj.source = err?.source;
        return obj;
      }) || [];
      this.errorArrayLength = data.descriptionError?.length;
    }
    if(data.descriptionError?.error?.length > 0) {
      this.errorArray = [];
      this.errorArray = data.descriptionError?.map(err => {
        const obj: any = {};
        if (err?.code) obj.code = err?.code;
        if (err?.message) obj.message = err?.message;
        if (err?.details) obj.details = err?.details;
        if (err?.source) obj.source = err?.source;
        return obj;
      }) || [];
      this.errorArrayLength = data.descriptionError?.error?.length;
    }
    if(popupErrors?.length > 0) {
      this.errorArray = [];
      for (const errorMessages of popupErrors){
        this.errorArray.push(errorMessages);
      }
      this.errorArrayLength = data.descriptionError?.fieldErrors?.length;
    }
    if (data?.descriptionError?.error) {
      this.errorDesc = [];
      const err = data.descriptionError.error;
        const obj: any = {};
        if (err?.code) obj.code = err?.code;
        if (err?.message) obj.message = err?.message;
        if (err?.details) obj.details = err?.details;
        if (err?.source) obj.source = err?.source;
        this.errorDesc = obj;
    }
    if (data.descriptionError?.messages) {
      this.errorMessages = data.descriptionError.messages[0];
    } else if(data.descriptionError?.message){
      this.errorMessages = data.descriptionError.message;
    } else if(data.descriptionError?.errmsg){
      this.errorMessages = data.descriptionError.errmsg;
    } else if(data.descriptionError?.error?.message){
      this.errorMessages = data.descriptionError.error.message;
    } else if(this.errorArrayLength > 0){ 
      this.errorMessages = data.subtitle?.length > 32 ? data.subtitle?.substring(0, 32) + '...' : data.subtitle;
    } else {
      if (data.descriptionError?.error  === translate('ERROR_DIALOG.NOT_FOUND')) {
        this.errorMessages = translate('ERROR_DIALOG.API_NOT_AVAILABLE');
      } else if (data.descriptionError) {
        this.errorMessages = typeof data.descriptionError === 'string'? data.descriptionError : 'An unknown error occurred.';;
      } else if (data.description?.error  !== translate('ERROR_DIALOG.NOT_FOUND')) {
        this.errorMessages = data.descriptionError?.error;
      }
    }
    this.isErrorDescription= this.errorDesc && Object.keys(this.errorDesc).length > 0 ? true :false
    data.descriptionError && ((this.errorDesc && Object.keys(this.errorDesc).length > 0) ||(this.errorArray && this.errorArray.length > 0) ) ?
     this.descriptionError = this.errorMessages :this.description =data.descriptionError ?  this.errorMessages : this.errorMessage;
    if(this.errorArray !== undefined) {
      this.errorArray = this.errorArray;
    }
  }

  ngOnInit(): void {
    this.copy = false;
    this.tenant = this.authService.principal.provider;
  }

  copyError(data, msg): void {
    this.copyErrorText = [];
    if (data.length > 0) {
      const code = this.translocoService.translate('ERROR_DIALOG.CODE');
      const message = this.translocoService.translate('ERROR_DIALOG.MESSAGE');
      const details = this.translocoService.translate('ERROR_DIALOG.DETAILS');
      const source = this.translocoService.translate('ERROR_DIALOG.SOURCE');
      this.copyErrorText = data.map(item => {
        const validEntries = [
          item.code ? `${code} ${item.code}` : '',
          item.message ? `${message} ${item.message}` : '',
          item.details ? `${details} ${item.details}` : '',
          item.source ? `${source} ${item.source}` : ''
        ].filter(value => value !== '');
        return validEntries.join('\n');
      }).join('\n\n');
    } else if(msg) {
      const code = this.translocoService.translate('ERROR_DIALOG.CODE');
      const message = this.translocoService.translate('ERROR_DIALOG.MESSAGE');
      const details = this.translocoService.translate('ERROR_DIALOG.DETAILS');
      const source = this.translocoService.translate('ERROR_DIALOG.SOURCE');
        const validEntries = [
          data.code ? `${code} ${data.code}` : '',
          data.message ? `${message} ${data.message}` : '',
          data.details ? `${details} ${data.details}` : '',
          data.source ? `${source} ${data.source}` : ''
        ].filter(value => value !== '');
        this.copyErrorText = validEntries;
    } else {
      this.copyErrorText = data;
    }
    this.copy = true;
    this.clipboardApi.copyFromContent(this.copyErrorText); // Copy full formatted text

    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  copyText(data,field?): void {
    if(field=== 'description'){
      this.copyData = data;
    }else{
    this.copyData = [];
    if(data.length > 0) {
      for (const description of data){
        this.copyData.push(description.message);
      }
    } else {
      this.copyData = data;
    }
    }
    this.copy = true;
    this.clipboardApi.copyFromContent(this.copyData);
    setTimeout(() => {
      this.copy = false;
    }, 5000);
  }

  openContactForm(): void {
    const url = `https://itsm-servicedesk.temenos.com`;
    window.open(url, '_blank');
  }

  toggleSelection(): void {
    this.matdialogRef.close(true);
  }

  onClick(): void {
    this.defaultLinkTitle =
      this.defaultLinkTitle ===
       translate('ERROR_DIALOG.VIEW_LESS') ? translate('ERROR_DIALOG.VIEW_MORE') : translate('ERROR_DIALOG.VIEW_LESS');
  }
}
